import { Actions, ActionTypes } from "./actions";
import { State, getInitialState } from "./state";

const initialState = getInitialState();

const reducer = (state: State = initialState, action: Actions): State => {
  switch (action.type) {
    case ActionTypes.setLoadingStep:
      return {
        ...state,
        currentStep: action.payload.step
      };

    case ActionTypes.setLoadingStepsEnabled:
      return {
        ...state,
        loadingStepsEnabled: true
      };

    case ActionTypes.clearLoadingStep:
      return {
        ...state,
        currentStep: null
      };

    default:
      return state;
  }
};

export { reducer, getInitialState };
